import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Checkout, CheckoutState } from "../interfaces/checkout";

const initialState: Checkout = {
    state: "empty",
    termsHtml: null,
    providerName: "",
    providerCode: "",
    programId: 0,
    programName: "",
    clientId: 0,
    providerId: 0,
    timezone: "",
    clientName: null,
    token: null,
};

const checkoutSlice = createSlice({
    name: "checkout",
    initialState,
    reducers: {
        setCheckoutState(state, action: PayloadAction<CheckoutState>) {
            state.state = action.payload;
        },
        setCheckout(state, action: PayloadAction<Checkout>) {
            return action.payload;
        },
        setClientId(state, action: PayloadAction<number>) {
            state.clientId = action.payload;
        },
        setClientName(state, action: PayloadAction<string>) {
            state.clientName = action.payload;
        },
        setToken(state, action: PayloadAction<string | null>) {
            state.token = action.payload;
        },

    },
});

export const {
    setCheckoutState,
    setCheckout,
    setClientId,
    setClientName,
    setToken,
} = checkoutSlice.actions;
export default checkoutSlice.reducer;
